import useMetaTags from "../hooks/useMetaTags"; // Adjust path based on your project structure

export default function Careers() {
  useMetaTags({
    title: "Careers | Join Organic Pads - Make a Difference in Sustainable Menstrual Care",
    description: "Explore exciting career opportunities with Organic Pads. Join us in revolutionizing eco-friendly menstrual care with sustainable and chemical-free products.",
    keywords: "organic pads careers, eco-friendly job opportunities, sustainable menstrual care jobs, work at Organic Pads, green jobs in hygiene industry",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/careers",
    ogTitle: "Careers | Join Organic Pads - Make a Difference in Sustainable Menstrual Care",
    ogDescription: "Looking for a rewarding career in sustainable menstrual care? Join Organic Pads and be a part of our eco-friendly mission!",
    ogImage: "https://organicpads.shop/images/careers-banner.jpg",
    ogUrl: "https://organicpads.shop/careers",
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "Careers | Join Organic Pads - Make a Difference in Sustainable Menstrual Care",
    twitterDescription: "Want to work in an eco-friendly company? Check out our career opportunities at Organic Pads and join our green mission!",
    twitterImage: "https://organicpads.shop/images/careers-banner.jpg",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
});

const schemaMarkup = {
  "@context": "https://schema.org",
  "@type": "JobPosting",
  "title": "Career Opportunities at Organic Pads",
  "description": "Join Organic Pads and be a part of our mission to provide sustainable, eco-friendly menstrual care products. We are hiring passionate individuals who believe in making a difference!",
  "hiringOrganization": {
    "@type": "Organization",
    "name": "Organic Pads",
    "url": "https://organicpads.shop",
    "logo": "https://organicpads.shop/images/logo.png"
  },
  "jobLocation": {
    "@type": "Place",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Your City",
      "addressRegion": "Your State",
      "addressCountry": "India"
    }
  },
  "employmentType": "Full-time",
  "datePosted": "2025-02-24",
  "validThrough": "2025-12-31",
  "applicantLocationRequirements": {
    "@type": "Country",
    "name": "India"
  },
  "sameAs": [
    "https://www.facebook.com/OrganicPads",
    "https://www.instagram.com/OrganicPads",
    "https://www.linkedin.com/company/OrganicPads"
  ]
}

    const jobOpenings = [
      {
        title: "Marketing Manager",
        location: "Remote",
        type: "Full-time",
        description: "Lead and execute digital marketing strategies to promote Organic Pads.",
      },
      {
        title: "Product Designer",
        location: "Bangalore, India",
        type: "Full-time",
        description: "Design sustainable and user-friendly packaging for our organic sanitary pads.",
      },
      {
        title: "Sales Executive",
        location: "Mumbai, India",
        type: "Part-time",
        description: "Drive sales and partnerships with local retailers and distributors.",
      },
    ];
  
    return (
      <>
      <div className="bg-gray-100 min-h-screen mt-20 p-6">
        {/* Hero Section */}
        <div className="text-center py-12 bg-[#679729] text-white rounded-lg">
          <h1 className="text-4xl font-bold">Join Our Team at Organic Pads</h1>
          <p className="mt-2 text-lg">Be part of a mission-driven company revolutionizing feminine hygiene.</p>
        </div>
        
        {/* Why Join Us */}
        <div className="max-w-4xl mx-auto mt-10">
          <h2 className="text-2xl font-bold text-gray-800 text-center">Why Work With Us?</h2>
          <ul className="mt-4 text-gray-700 space-y-2">
            <li>🌿 Make a real impact on women's health and sustainability.</li>
            <li>💡 Work with a passionate and innovative team.</li>
            <li>📈 Growth opportunities in an expanding industry.</li>
            <li>🏡 Flexible work options – remote and hybrid roles available.</li>
          </ul>
        </div>
  
        {/* Job Openings */}
        <div className="max-w-4xl mx-auto mt-10">
          <h2 className="text-2xl font-bold text-gray-800 text-center">Current Openings</h2>
          <div className="mt-6 space-y-6">
            {jobOpenings.map((job, index) => (
              <div key={index} className="p-6 bg-white shadow-lg rounded-lg">
                <h3 className="text-xl font-semibold">{job.title}</h3>
                <p className="text-gray-600 mt-1">{job.location} • {job.type}</p>
                <p className="text-gray-700 mt-2">{job.description}</p>
                <button className="mt-4 px-4 py-2 bg-[#679729] text-white rounded hover:bg-green-700">
                  Apply Now
                </button>
              </div>
            ))}
          </div>
        </div>
  
        {/* Apply Section */}
        <div className="max-w-3xl mx-auto mt-12 bg-white p-6 shadow-lg rounded-lg">
          <h2 className="text-2xl font-bold text-gray-800 text-center">Apply Now</h2>
          <form className="mt-4 space-y-4">
            <input type="text" placeholder="Full Name" className="w-full p-2 border rounded" required />
            <input type="email" placeholder="Email Address" className="w-full p-2 border rounded" required />
            <input type="file" className="w-full p-2 border rounded" required />
            <button className="w-full p-2 bg-[#679729] text-white rounded">
              Submit Application
            </button>
          </form>
        </div>
      </div>
       {/* Schema Markup */}
       <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
      </>
    );
  }
  